import { createFileRoute } from '@tanstack/react-router'
import { StatsGrid } from '../../../../components/StatsGrid'
import { useStats } from '../../../../hooks/useApi'

export const Route = createFileRoute('/platform/desa/$desaId/statistik')({
  component: () => {
    const { desaId } = Route.useParams()
    const { data, isLoading } = useStats(desaId)

    return <StatsGrid data={data} isLoading={isLoading} desaId={desaId} />
  },
})
